<template>

  <div class="container-fluid">
    <div class="row">

      <!-- Right Panel -->
      <div class="col-sm-5 item-right">


        <div class="form-container">

          <div id="Logo">
            <img src="../assets/images/logo.png" id="logo">
          </div>
 
            <h2>Business Login</h2>
            <br>

              <template v-if="ShowForm">
                      
                      <form class="text-center" @submit.prevent="Login">

                        <div class="form-group col-md-12">
                          <input type="email" class="form-control EnterMobile" v-model="FormInfo.Email" placeholder="Enter Email" required>
                        </div>

                        <div class="form-group col-md-12 button">
                          <input type="submit" value="Next" class="btn btn-primary btn-block Next" id="LoginButton" />

                        </div>

                      </form>

              </template>             


              <template v-if="ShowEnterOTP">
                      
                <p>Verification code has been sent to your email address. Please also check your spam folder.</p>

                      <form class="text-center" @submit.prevent="VerifyOTP">

                        <div class="form-group col-md-12">
                          <input type="tel" class="form-control EnterMobile" v-model="FormInfo.OTP" placeholder="Enter 6 Digit Verification Code" minlength="6" maxlength="6" required>
                        </div>

                        <div class="form-group col-md-12 button">
                          <input type="submit" value="Verify" class="btn btn-primary btn-block Next" id="LoginButton" />
                        </div>

                      </form>

              </template>


              <template v-if="ShowSignUp">
                      
                <p>Awesome, let's create your acount.<br>It'll take less than a miniute...</p>

                      <form class="text-center" @submit.prevent="StartSignUp">

                        <div class="form-group col-md-12">
                          <input type="text" class="form-control" v-model="FormInfo.CompanyName" placeholder="Business Name" minlength="2" required>
                        </div>

                        <div class="form-group col-md-12">
                          <input type="text" class="form-control" v-model="FormInfo.ContactPerson" placeholder="Your Name" minlength="2" required>
                        </div>

                        <div class="form-group col-md-12 text-left">
                          <autocomplete
                            ref="autocomplete"
                            placeholder="Search Country"
                            :source="Country"
                            input-class="form-control"
                            results-property="data"
                            @selected="SelectCountry"
                            >
                          </autocomplete>
                        </div>


                        <div class="form-group col-md-12 button">
                          <input type="submit" value="Sign Up" class="btn btn-primary btn-block Next" id="LoginButton" />
                        </div>

                      </form>

              </template>


            <div v-if="ShowLoading">
              <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw loading"></i>
            </div>

            <transition name="fade" v-if="ShowError">
              <h5 class="error">
                {{ErrorMsg}}
              </h5>
            </transition>

          </div>

      </div>

      <!-- Left Panel -->
      <div class="col-sm-7 item-left">


      </div>
      <!-- End of Left Panel -->

    </div>
  </div>
</template>

<script>

import { db } from '../main.js';
// import api from '../api'
import axios from 'axios';
import moment from 'moment';
import Autocomplete from 'vuejs-auto-complete';
// import {
//   globalStore
// } from '../main.js';

// import { VueTelInput } from 'vue-tel-input'
import VuePhoneNumberInput from 'vue-phone-number-input';

export default {
  components: {
    Autocomplete
  },
  name: 'Login',
  data(router) {
    return {
      OTP: '',
      ShowForm: true,
      ShowEnterOTP: false,
      ShowLoading: false,
      ShowSignUp: false,
      ShowError: false,
      SignUp: false,
      ErrorMsg: "",
      SignUpCompanyId: "",
      FormInfo: {
        Email: "",
        Password: ""
      },
      UserInfo: {},
      LocationInfo: {},
      Country: []
    }
  },
  mounted: function() {
    console.log("Login Mounted");
    // this.GetCountryCode();
  },
  methods: {
    GetCountryCode() {
      console.log("GetCountryCode");

        db.collection("CountryCodes")
          .get()
          .then((snap) => {
            console.log(snap.docs.length)
            // console.log("CountryCodes: "+snap.docs.length);

              snap.docs.forEach(doc => {

                  this.Country.push({
                    id: doc.id,
                    name: doc.data().name,
                    dial_code: doc.data().dial_code,
                  });
              });


              setTimeout(()=>{
                console.log("Countries: "+this.Country.length);
              },1000)

          })
          .catch(function(error) {
            alert('Network Error!');
            console.log("Error getting document:", error);
          });


    },
    Login(){

      this.ShowLoading = true;

      console.log("Login...");
      console.log(this.FormInfo.Email);


        // this.TempLogin();

        db.collection("Company")
          .where('Email','==',this.FormInfo.Email)
          .get()
          .then((snap) => {
            console.log(snap.docs.length)

            if(snap.docs.length == 1){

              console.log("User Exists");

              snap.docs.forEach(doc => {
                console.log("DocId: " + doc.id);
                console.log("Name: " + doc.data().ContactPerson);
                console.log("Email: " + doc.data().Email);

                this.UserInfo.id = doc.id;
                this.UserInfo.ContactPerson = doc.data().ContactPerson;
                this.UserInfo.Email = doc.data().Email;

                this.OTP = Math.floor(100000 + Math. random() * 900000);
                console.log("OTP: ",this.OTP);

                var msg = "Hello,<br><br>Verification Code for Visity is "+this.OTP+". Please do not share this with anyone. <br><br>Thank you,<br>Team Visity";

                  var info = {
                    Email: this.FormInfo.Email,
                    Subject: "Verification Code - "+this.OTP,
                    Message: msg
                  };

                  console.log("Email Payload: "+JSON.stringify(info, null, 2));
     

     
                      // // Send Verification via Email
                      axios.post("https://us-central1-visity-usa.cloudfunctions.net/widgets/send-email", info).then((res) => {
                        console.log(res);

                        var response = res;

            
                        if(response.data == "Success"){
                          this.ShowLoading = false;
                          this.ShowForm = false;
                          this.ShowEnterOTP = true; 
                          this.ShowError = false;
                        }

                      }).catch((e) => {

                        console.log(e);

                            this.ErrorMsg = "Error Sending OTP: "+e;
                            this.ShowLoading = false;
                            this.ShowError = true;

                            setTimeout(()=>{
                              this.ShowError = false;
                            },2000);

                      });

              })

            }else{

              // ------ Show Sign Up Form ----------

              console.log("User Does Not Exist.");
              console.log("Send OTP for Email Verification");

              this.SignUp = true;
              this.SendOTPviaEmail();

              // // alert('User Does Not Exist');
              // this.ShowLoading = false;
              // this.ErrorMsg = "Sorry, email does not exist. Please try again.";
              // this.ShowError = true;

              // setTimeout(()=>{
              //   this.ShowError = false;
              //   this.ShowLoading = false;
              // },3000);

            }

          })
          .catch(function(error) {
            alert('Network Error!');
            console.log("Error getting document:", error);
          });

    },
    // ------- This is only for Sign Up ------- 
    SendOTPviaEmail(){

                this.OTP = Math.floor(100000 + Math. random() * 900000);
                console.log("OTP: ",this.OTP);

                var msg = "Hello,<br><br>Verification Code for Visity is "+this.OTP+". Please do not share this with anyone. <br><br>Thank you,<br>Team Visity";

                  var info = {
                    Email: this.FormInfo.Email,
                    Subject: "Verification Code - "+this.OTP,
                    Message: msg
                  };

      console.log("SendOTP");

                      // // Send Verification via Email
                      axios.post("https://us-central1-visity-usa.cloudfunctions.net/widgets/send-email", info).then((res) => {
                        console.log(res);

                        var response = res;

            
                        if(response.data == "Success"){
                          this.ShowLoading = false;
                          this.ShowForm = false;
                          this.ShowEnterOTP = true; 
                          this.ShowError = false;
                        }

                      }).catch((e) => {

                        console.log(e);

                            this.ErrorMsg = "Error Sending OTP: "+e;
                            this.ShowLoading = false;
                            this.ShowError = true;

                            setTimeout(()=>{
                              this.ShowError = false;
                            },2000);

                      });

    },
    VerifyOTP(){

      this.ShowLoading = true;

      console.log("Verify OTP");
      console.log("Entered OTP: "+this.FormInfo.OTP);

      if(this.OTP == this.FormInfo.OTP){
        console.log("Correct OTP.");
        console.log("Login.");


              if(!this.SignUp){

                localStorage.setItem("AdminId", this.UserInfo.id);
                localStorage.setItem("AdminName", this.UserInfo.ContactPerson);
                localStorage.setItem("AdminEmail", this.UserInfo.Email);

                this.$router.push("/admin");

              }else{

                this.GetCountryCode();

                this.ShowSignUp = true;
                this.ShowEnterOTP = false;
                this.ShowLoading = false;

              }



      }else{
        
        this.ErrorMsg = "Incorrect Verification Code, please try again.";
        this.ShowError = true;
      }


    },
    StartSignUp(){

      console.log("Start SignUp");

      console.log("Email: "+this.FormInfo.Email);
      console.log("Business Name: "+this.FormInfo.CompanyName);
      console.log("ContactPerson: "+this.FormInfo.ContactPerson);

      // ---- Generate Invite Code ----
      var InviteCode = Math.floor(Math.random() * (999999 - 100000)) + 100000;
      this.FormInfo.InviteCode = InviteCode.toString();

      // --- Set Payload for Location ----------
      this.LocationInfo = this.FormInfo;

            // ---------------- Create Organization -----------------------

            console.log("Upload to DB Started");

            this.FormInfo.Designation = "";
            this.FormInfo.Mobile = "";
            this.FormInfo.CreatedOn = moment().format();
            this.FormInfo.Active = true;
            this.FormInfo.Version = 2;
            this.FormInfo.Assigned = true;
            this.FormInfo.SalesRep = "Web SignUp";
            this.FormInfo.Menu = false;
            this.FormInfo.Feedback = false;
            this.FormInfo.Marketing = false;
            this.FormInfo.VisitPurpose = [
              "Guest",
              "Meeting",
              "Delivery",
              "Repair & Services",
              "Emergency Services",
              "Other"
            ];

            console.log("Payload: "+JSON.stringify(this.FormInfo));

              db.collection("Company")
                .add(this.FormInfo)
                .then((res) => {
                  console.log(res);
                  console.log("Company Created Successfully");

                  console.log("CompanyId: "+res.id);
                  this.SignUpCompanyId = res.id;

                  this.NewSignUpNotification();
                  this.CreateLocation();

                });     


    },
    CreateLocation(){

      console.log("Create Location...");

        this.LocationInfo.CompanyId = this.SignUpCompanyId;
        this.LocationInfo.Location = "HQ";
        this.LocationInfo.AccessType = "Admin";
        this.LocationInfo.CreatedOn = moment().format();
        this.LocationInfo.Active = true;
        this.LocationInfo.Parameters = {
          ApproveVisitor: false,
          VisitType: false,
          WhomToMeet: false
        };
        this.LocationInfo.VisitPurpose = [
          "Guest",
          "Meeting",
          "Delivery",
          "Repair & Services",
          "Emergency Services",
          "Other"
        ];

            console.log("Location Payload: "+JSON.stringify(this.LocationInfo));

              db.collection("Location")
                .add(this.LocationInfo)
                .then((res) => {
                  console.log(res);
                  console.log("Location Created Successfully");

                    localStorage.setItem("AdminId", this.SignUpCompanyId);
                    localStorage.setItem("AdminName", this.FormInfo.ContactPerson);
                    localStorage.setItem("AdminEmail", this.FormInfo.Email);

                    this.$router.push("/admin");

                });     


    },
    NewSignUpNotification(){

                  var sub = "New Sign Up - "+this.FormInfo.CompanyName
                  var msg = "New SignUp<br><br>Email: "+this.FormInfo.Email+"<br>Company: "+this.FormInfo.CompanyName+"<br>Name: "+this.FormInfo.ContactPerson+"<br><br>Cheers,<br>Team Visity";

                  var info = {
                    Subject: sub,
                    Message: msg
                  };

                  console.log("Email Payload: "+JSON.stringify(info, null, 2));
     
                      // // Send Email
                      axios.post("https://us-central1-visity-usa.cloudfunctions.net/widgets/upgrade-request", info).then((res) => {
                        console.log(res);
                        var response = res;
                      }).catch((e) => {
                        console.log(e);
                      });            



    },
    SelectCountry(info){
      console.log("SelectCountry");
      console.log(info.selectedObject.dial_code);
      this.FormInfo.CountryCode = info.selectedObject.dial_code;
    },
    TempLogin(){

                console.log("Temp Login");

                localStorage.setItem("AdminId", "123456");
                localStorage.setItem("AdminName", "Amish Thaker");
                localStorage.setItem("AdminEmail", "thaker.amish@gmail.com");

                this.$router.push("/admin");

    }
  }
}
</script>


<style scoped="">

  #msd-logo{
    width: 180px;
  }

.container-fluid, .item-left, .item-right{
  height: 100vh;
}

.item-left{
  /* border: 1px solid red; */
  /*background-color: #039BE5;*/
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
   background-image: url('../assets/images/background5.jpg'); 
  /* background-image: linear-gradient( rgba(112,112,112, 0.7), rgba(112,112,112, 0.7)), url('/static/img/bg-2.jpg'); */
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

#Logo{
  align-self: center;
  text-align: center;
}

.item-right{
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
}

.form-container{
  align-self: center;
  /* padding: 2em; */
  /* border: 1px solid #000000; */
  border-radius: 1em;
  padding: 1em;
  width: 80%;
  text-align: center;
  color: #808080;
}

#inputEmail, #inputPassword{
  border-radius: 2em;
}

#LoginButton{
  background-color: #008AFC;
  border: 1px solid #008AFC;
  border-radius: 2em;
  color: #ffffff;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* ----------------------- Old styling --------------------------- */

h3 {
  color: white;
}

#logo{
  width: 10em;
}

/* #LoginForm{ background-image:url("https://hdwallsource.com/img/2014/9/blur-26347-27038-hd-wallpapers.jpg");  background-position:center; background-size:cover;} */
.LoginForm {
  background-color: #5b7fc8;
  height: 55em;
  padding-top: 5%;
}

.form-heading {
  color: #fff;
  font-size: 23px;
}

.panel h2 {
  color: #444444;
  font-size: 18px;
  margin: 0 0 8px 0;
}

.panel p {
  color: #777777;
  font-size: 14px;
  margin-bottom: 30px;
  line-height: 24px;
}

.login-form .form-control {
  background: #f7f7f7 none repeat scroll 0 0;
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
}

.error {
  color: red;
  font-size: 15px;
  font-weight: 15px;
}

.main-div {
  background: #5b7fc8 none repeat scroll 0 0;
  border-radius: 2px;
  margin: 10px auto 30px;
  max-width: 38%;
  padding: 50px 70px 70px 71px;
}

.login-form .form-group {
  margin-bottom: 10px;
}

.login-form {
  text-align: center;
}

.forgot a {
  color: #777777;
  font-size: 14px;
  text-decoration: underline;
}

.login-form .btn.btn-primary {
  background: #f0ad4e none repeat scroll 0 0;
  border-color: #f0ad4e;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0;
}

.forgot {
  text-align: left;
  margin-bottom: 30px;
}

.botto-text {
  color: #ffffff;
  font-size: 14px;
  margin: auto;
}

.login-form .btn.btn-primary.reset {
  background: #ff9900 none repeat scroll 0 0;
}

.back {
  text-align: left;
  margin-top: 10px;
}

.back a {
  color: #444444;
  font-size: 13px;
  text-decoration: none;
}

.EnterMobile{
  border-radius: 2em;
}

.Next{
  border-radius: 5px;
  font-weight: bold;
  text-transform: uppercase;
  background-color: #458afc;
}


.SelectCountry{
  border-radius: 2em;
}

.autoCompleteClass{
  border: none;
  background: green;
}


</style>

